import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { makeStyles, Theme } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { RowNode } from 'ag-grid-community';
import React, { useEffect, useState } from 'react';

import {
  useTableGridApiDispatch,
  useTableGridApiState,
} from '../../../TableGridApiContext/TableGridApiContext';
import { TableGridApiAction } from '../../../TableGridApiContext/TableGridApiContext.types';
import { getNodeIdGetter } from '../HeaderSelectAllRenderer/selectAllRenderer.utils';

const SelectRowRenderer: React.FC<ICellRendererParams> = (props) => {
  const classes = useStyles();
  const dispatchTableApi = useTableGridApiDispatch();
  const {
    selectedRows,
    rowSelectionIdGetter,
    tableGridApi,
    rowsAndIdsOrder,
  } = useTableGridApiState();
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const getNodeId = getNodeIdGetter(rowSelectionIdGetter);
  const id = getNodeId(props);

  useEffect(() => {
    const isSelected = selectedRows.indexOf(id) !== -1;
    setIsSelected(isSelected);
    props.node.setSelected(isSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows]);

  const handleClick = () => {
    const orderIds: any = rowsAndIdsOrder;
    tableGridApi.forEachNode((node: RowNode) => {
      const id = getNodeId(node);
      if (orderIds && id !== orderIds.id) {
        orderIds[id] = node.id;
      }
    });

    dispatchTableApi({
      type: TableGridApiAction.AddRowsAndIdsOrder,
      payload: orderIds,
    });

    dispatchTableApi({
      type: !isSelected
        ? TableGridApiAction.AddSelectedRows
        : TableGridApiAction.RemoveSelectedRows,
      payload: [id],
    });
  };

  return <Checkbox checked={isSelected} onChange={handleClick} color="primary" classes={classes} />;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginLeft: '-4px',
    padding: 0,
    color: theme.palette.secondary.dark,

    '&$checked': {
      color: theme.palette.primary.contrastText,
    },
  },
  checked: {},
}));

export default SelectRowRenderer;
